import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16","key":"svg-0"}]]

/**
 * IconFlag3
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZmxhZy0zIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDE0aDE0bC00LjUgLTQuNWw0LjUgLTQuNWgtMTR2MTYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/flag-3
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconFlag3 = createReactComponent('outline', 'flag-3', 'Flag3', __iconNode);

export default IconFlag3;